{
  "maxFileSizeInMegabytes": 100
}
